module.exports = __webpack_public_path__ + "img/5-1_08.8310655e.jpg";